// TB-071: imported first by main.js, before any module that touches storage.
// When the browser blocks site data, swap in memory storage for this tab.
// (The single start-up warning is logged by firebase.js.)
import { installStorageFallback } from './safeStorage'

installStorageFallback()
